module.exports = __webpack_public_path__ + "static/media/ahmed-portrait.39080d78.jpg";